import React, { useContext } from 'react';
import styled from 'styled-components';
import { BetTracker, Caesars, WilliamHill } from './logos';
import { ServicesContext } from '../services/services-provider';
import config from '../config';

const placeholder = <div style={{ width: 110 }}></div>;

export default function CompositeLogo() {
  const context = useContext(ServicesContext);
  const displayLogos = !context.loading && context.dynamicConfig?.HIDE_LOGOS !== true;
  const logo = !displayLogos ? placeholder : config.BRANDING === 'WILLIAM_HILL' ? <WilliamHill /> : <Caesars />;

  return (
    <Wrapper>
      <LogoWrapper>{logo}</LogoWrapper>
      {displayLogos && <Divider />}
      <BetTracker />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  min-height: 38px; /* stops layout shift when logos are loading */
`;

const LogoWrapper = styled.div`
  flex-grow: 1;
`;

const Divider = styled.div`
  background-color: #000000;
  content: '';
  display: block;
  margin: 0 1rem;
  height: 33px;
  width: 1px;
`;
